<div class="container">
	<div class="menu-body">
		<div class="d-f ai-c ml-nano head">
			<button
				mat-icon-button
				aria-label="Toggle menu"
				(click)="closeEvt.emit()"
			>
				<mat-icon svgIcon="sanus-closeb"></mat-icon>
			</button>
			<img
				class="ml-xxxs logo"
				src="../../assets/images/logo_sanus.svg"
				alt="logo"
			/>
		</div>
		<div
			class="d-f fd-c mt-nano mb-nano"
			*ngFor="let item of menu; let index = index"
		>
			<section
				class="d-f jc-sb ai-c ml-xxxs mr-xxs pl-xxxs br-pill c-p item"
				(pointerover)="hoverIdx = index; outCount = 0"
				(pointerout)="onMoveOut()"
				(click)="onMenuItemClick(index)"
				(keydown)="onMenuItemClick(index)"
				tabindex="0"
				role="button"
			>
				<div class="d-f ai-c">
					<ng-container
						*ngIf="
							item.icon.startsWith('sanus') ||
								item.icon.startsWith('material-');
							else matIcon
						"
					>
						<mat-icon
							[svgIcon]="hoverIdx === index ? item.icon + '-white' : item.icon"
						></mat-icon>
					</ng-container>

					<ng-template #matIcon>
						<mat-icon>{{ item.icon }}</mat-icon>
					</ng-template>

					<span class="ml-nano fs-xxs lh-xxs">{{ item.label }}</span>

					<ng-container *ngIf="item.subItems?.length">
						<mat-icon
							*ngIf="activeIdx !== index"
							[svgIcon]="
								hoverIdx === index
									? 'sanus-chevron-right-white'
									: 'sanus-chevron-right'
							"
							(pointerover)="outCount = 0"
						></mat-icon>
						<mat-icon
							*ngIf="activeIdx === index"
							[svgIcon]="
								hoverIdx === index
									? 'sanus-chevron-down-white'
									: 'sanus-chevron-down'
							"
							(pointerover)="outCount = 0"
						></mat-icon>
					</ng-container>
				</div>
				<div class="d-f ai-c jc-c badge" *ngIf="item.badge">
					{{ item.badge.label }}
				</div>
			</section>
			<div *ngIf="activeIdx === index && item.subItems?.length">
				<div
					class="d-f fd-c mt-nano mb-nano"
					*ngFor="let sub of item.subItems; let indexS = index"
				>
					<div
						class="d-f ai-c ml-xxxs mr-xxs pl-xxxs br-pill c-p item"
						(click)="onSubmenuItemClick(index, indexS)"
					>
						<mat-icon svgIcon="sanus-bullet"></mat-icon>
						<span class="ml-nano fs-xxs lh-xxs">{{ sub.label }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
